import api from "./api";

export interface BrandingConfig {
  nome?: string;
  corPrimaria?: string;
  /** Cor de ação dominante — botões, links, focus, badges. Default #2563eb. */
  corSecundaria?: string;
  /** Cor exclusiva do chat (bolhas, avatares de grupo, FAB, IA). Default #0ea5e9. */
  corChat?: string;
  logoUrl?: string;
  faviconUrl?: string;
  /** Altura máxima da logo na sidebar (px). Default 48. Range 20-80. */
  logoEscala?: string;
  /** MELHORIA 21 — logo (preta) usada no cabeçalho do relatório (imprime no PDF).
   *  A logoUrl normal costuma ser branca (sidebar escura) e some no papel. */
  logoRelatorioUrl?: string;
}

export async function getBrandingPublico() {
  const r = await api.get("/configuracoes/publico");
  return r.data.data as BrandingConfig;
}

export async function getBrandingCompleto() {
  const r = await api.get("/configuracoes");
  return r.data.data as BrandingConfig;
}

export async function atualizarBranding(dados: Partial<BrandingConfig & { logoUrl: string | null; faviconUrl: string | null; corPrimaria: string | null; corSecundaria: string | null; corChat: string | null; nome: string | null }>) {
  const r = await api.patch("/configuracoes", dados);
  return r.data.data as BrandingConfig;
}

export async function uploadBrandingFile(chave: "logoUrl" | "faviconUrl" | "iaFotoUrl" | "logoRelatorioUrl", file: File) {
  const fd = new FormData();
  fd.append("file", file, file.name);
  const r = await api.post(`/configuracoes/upload/${chave}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data.data as { url: string };
}

export interface IAInfo {
  nome: string;
  fotoUrl: string | null;
}

export async function getIaInfo() {
  const r = await api.get("/configuracoes/ia");
  return r.data.data as IAInfo;
}

// Configuração técnica do backend de IA (admin only).
// iaApiKey só vem preenchido pra perfil admin; pra outros vem `iaApiKeyDefinida = "true"`.
export interface IAConfig {
  iaNome?: string;
  iaFotoUrl?: string;
  iaApiKey?: string;
  iaApiKeyDefinida?: string; // "true" quando há chave salva (mesmo sem retornar o valor)
  iaModel?: string;
  iaBaseUrl?: string;
}

export async function getConfiguracoesCompletas() {
  const r = await api.get("/configuracoes");
  return r.data.data as Record<string, string>;
}

export async function atualizarIa(dados: Partial<{
  iaNome: string | null;
  iaFotoUrl: string | null;
  iaApiKey: string | null;
  iaModel: string | null;
  iaBaseUrl: string | null;
  iaSemTools: string | null;     // "true" / "false"
  iaTemperatura: string | null;  // ex.: "0.7"
}>) {
  const r = await api.patch("/configuracoes", dados);
  return r.data.data;
}
